import React, { useState, useEffect, useRef} from "react";
import "./editfaq.css";
import Sidebar from "../Sidebar";
import { useDispatch } from "react-redux";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom'
import { faqdetailAction, posteditfaqAction, faqcategoryAction, deletefaqimgAction } from "../../actions/faqAction";
import { decode } from "base-64";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import Header from "../../component/loaderComponent/Header/Header";
import { notify } from '../../services/notification';

function CreateFaq() {

  const [states, setDataStates] = useState({
    faq_type: "",
    category: "",
    question: "",
    send_to_type: "", 
    answer: "",
    heading: null,
    description: null,
    link: "",
    attachmentFileName: "",
    send_to: "",
    attachmentFileUrl: "",
  })
  const [categorydata, setcategorydata] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const [attachment, setattachment] = useState([]);
  const [textCount, setTextCount] = useState(0);
  const [textCounts, setTextCounts] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams()
  const decodeid = decode(id)


  useEffect(() => {
    CategotyDeatails();
    FaqDeatailsData();

  }, []);

  async function CategotyDeatails() {
    let response = await dispatch(faqcategoryAction());
    if (response == 200 || response != null) {
      setcategorydata(response?.data?.data)
    }
  }

  async function FaqDeatailsData() {
    let response = await dispatch(faqdetailAction(decodeid));
    if (response == 200 || response != null) {
      setattachment(response.data.data.attachment)
      setTextCounts((response.data.data.question).length)
      setTextCount((response.data.data.answer).length)
     
      setDataStates({
        ...states,
        faq_type: response.data.data.faq_type,
        category: response.data.data.category,
        question: response.data.data.question,
        answer: response.data.data.answer,

      });
    }
  }
  const fileInputRefs = useRef(null);
  const handleFileUpload = (event) => {
    const files = event.target.files;
    if (attachment.length === 0) {
      const maxFiles = 2;
      if (selectedFile.length <= maxFiles && files.length <= 3) {
        setSelectedFile([...selectedFile, ...files]);
      } else {
        notify.error('You can only upload a maximum of 3 files.');
      }
    }
    else if (attachment.length === 1) {
      const maxFiles = 1;
      if (selectedFile.length <= maxFiles && files.length <= 2) {
        setSelectedFile([...selectedFile, ...files]);
      } else {
        notify.error('You can only upload a maximum of 3 files.');
      }
    }
    else if (attachment.length === 2) {
      const maxFiles = 0;
      if (selectedFile.length <= maxFiles && files.length <= 1) {
        setSelectedFile([...selectedFile, ...files]);
      } else {
        notify.error('You can only upload a maximum of 3 files.');
      }
    }
    else if (attachment.length === 3) {
      notify.error('You can only upload a maximum of 3 files.');
    }

  }
  function updateCharsters(e) {
    const text = document.getElementById("text2").value;
    setTextCounts(text.length);
  }

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, ''),
    });
    updateChars();
    updateCharsters();
  };
  const handleDownload = (attachurl) => {
    const link = document.createElement("a");
    link.href = attachurl;
    link.download = "myfile.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const updateFaq = async (event) => {
    event.preventDefault();
    let data = new FormData();
    if (selectedFile === "") {
      data.append('faq_type', states.faq_type);
      data.append('category', states.category);
      data.append('question', states.question);
      data.append('answer', states.answer);
    }
    else {
      selectedFile.forEach((file, i) => {
        data.append(`attachment`, file);
      });
      data.append('faq_type', states.faq_type);
      data.append('category', states.category);
      data.append('question', states.question);
      data.append('answer', states.answer);
    }
    setIsLoading(true);
    let response = await dispatch(posteditfaqAction(data, decodeid));
    if (response == 200 || response != null) {
      if(selectedIds.length>0){
        FaqImgDelete();
        setIsLoading(false);
        notify.success("FAQ update successfully.")
        navigate('/faq')
        window.scroll(0, 0)
    }
     else{
      setIsLoading(false);
      notify.success("FAQ update successfully.")
      navigate('/faq')
      window.scroll(0, 0)
     }
    }
  };

  const FaqImgDelete = async () => {
    let apiReq = {
      id: selectedIds
    };
    setIsLoading(true);
    let response = await dispatch(deletefaqimgAction(selectedIds));
    if (response == 200 || response != null) {
      setIsLoading(false);
      notify.success("Attachment Delete Successfully");
      CategotyDeatails();
      FaqDeatailsData();
    }
  };

  function updateChars() {
    const text = document.getElementById("text").value;
    setTextCount(text.length);
  }
  

  function handleFileRemove(index) {
    if (selectedFile.length == 1) {
      setSelectedFile([]);
      if (fileInputRefs.current){
        fileInputRefs.current.value = null;
      }
    }
    const newFiles = [...selectedFile];
    newFiles.splice(index, 1);
    setSelectedFile(newFiles);
  }

  

  function imageremove(index, id) {
    const Files = [...attachment];
    Files.splice(index, 1);
    setattachment(Files);
    setSelectedIds((prevIds) => {
      if (prevIds.includes(id)) {
        // Remove the ID if it already exists
        return prevIds.filter((prevId) => prevId !== id);
      } else {
        // Add the ID if it doesn't exist
        return [...prevIds, id];
      }
    });
  }
  return (
    <div className="Create_faq_Conatiner">
      <div className="Faq_Sidebar">
        <Sidebar />
      </div>
      <div className="Faq_Content">
        <Header title="Edit FAQ" />
        {isLoading ? <Loader /> :
          <div className="View__CreateP_faq">
            <div className="Question_categorys_s">
              <span>Question Category<span style={{ color: "red" }}>*</span></span>
              <select className="text_fileddropdown_s__s" name="category" value={states.category} onChange={handleChange}>
                {categorydata?.map((data) =>
                  <option value={data.id} selected> {data.category}</option>)}
              </select>
            </div>
            <div className="Question_category">
              <span> Question<span style={{ color: "red" }}>*</span></span>
              <textarea
                type="text"
                className="input_Text__EnterValue_A"
                placeholder="Question"
                name="question"
                value={states.question}
                onChange={handleChange}
                rows={10}
                cols={50}
                id="text2"
                maxLength={100}
              />
              <p className='textcount_question montserrat-font'>{textCounts}/50</p>
            </div>
            <div className="Question_category">
              <span> Answer<span style={{ color: "red" }}>*</span></span>
              <textarea
                type="text"
                className="input_Text__EnterValue_A_A"
                placeholder="Answer"
                value={states.answer}
                name="answer"
                onChange={handleChange}
                rows={10}
                cols={50}
                id="text"
                maxLength={500}
              />
              <p className='textcount_answer montserrat-font'>{textCount}/500</p>
            </div>
            <div className="LINK_aTT">
              <div className="Question_category_s">
                <div className="LinkAttachments">
                  <span id="upload-text">Attachment</span>
                  <label  htmlFor="formId" className="upload-box">
                    <input name="" type="file" id="formId" hidden  ref={fileInputRefs} onChange={handleFileUpload} accept="image/png,image/jpg,image/jpeg,.pdf"
                      multiple />
                    Choose Files
                  </label>
                </div>
              </div>
              <ul className="">
                {attachment.map((file, ind) => (
                  <>
                    <li className="file_nameAttach" key={ind} >
                      {file.attachment?.endsWith('.jpg') || file.attachment?.endsWith('.png') || file.attachment?.endsWith('.jpeg') || file.attachment?.endsWith('.webp') ?
                        <span >
                          <img
                            src={file.attachment}
                            key={ind}
                            alt="preview"
                            height="100px"
                            width="100px"
                          />
                        </span>
                        : <>
                          {file.attachment.substring(file.attachment.lastIndexOf("/") + 1)}
                        </>}
                      <img
                        alt="Delete_icons"
                        className="cursor-pointer Delete_icons"
                        src={Image_Url.DELETE_ICONS}
                        onClick={() => imageremove(ind, file.id)}
                      />
                    </li>
                    {file.attachment !== "" ?
                      <div className="">
                        <span className="download_editbtn " onClick={() => { handleDownload(file.attachment); }} >
                          Download</span>
                      </div>
                      : ""}
                  </>
                ))}

                {selectedFile.map((data, i) =>
                  <li className="file_nameAttach" key={i}>
                    <span>{data.name}
                      <img
                        alt="Delete_icons"
                        className="cursor-pointer Delete_icons"
                        src={Image_Url.DELETE_ICONS}
                        onClick={() => handleFileRemove(i)} />
                    </span>
                  </li>

                )}
              </ul>
            </div>
            <div className="createfaqbutton">
              <button className="createfaq_buttonAll" onClick={() => navigate('/faq')}>Close</button>
              <button className="updatefaq_buttonAll"
                disabled={states.question === "" || states.answer === "" || states.category === ""}
                onClick={updateFaq}
              >Update</button>
            </div>
          </div>
        }
      </div>
    </div>
  );
}
export default CreateFaq;
